import { theme, subscribe, PUB_SUB_EVENTS } from './global.js';
import { getWishlist } from './wishlist-compare.js';
import { addToCart } from './cart.js';
import './sticky-header.js';
import './drag-scroll.js';
import './mobile-tab-bar.js';

const dropdowns = Array.from(document.querySelectorAll('[data-header-list-dropdown]'));

function getHandles() {
  return getWishlist();
}

async function renderDropdown(el) {
  const type = el.dataset.headerListDropdown;
  const handles = getHandles(type);
  const emptyEl = el.querySelector('[data-list-empty]');
  const itemsEl = el.querySelector('[data-list-items]');
  const actionsEl = el.querySelector('[data-list-actions]');

  if (!handles.length) {
    emptyEl.hidden = false;
    itemsEl.hidden = true;
    actionsEl.hidden = true;
    itemsEl.innerHTML = '';
    return;
  }

  emptyEl.hidden = true;
  itemsEl.hidden = false;
  actionsEl.hidden = false;

  const products = (
    await Promise.all(
      handles
        .slice(0, 5)
        .map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null))
    )
  ).filter(Boolean);

  itemsEl.innerHTML = products
    .map((p) => {
      const image = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_100x$1$2') : '';
      return `
        <li class="header-list-dropdown__item">
          ${image ? `<img src="${image}" alt="" loading="lazy">` : ''}
          <a href="${p.url}" class="header-list-dropdown__item-title">${p.title}</a>
        </li>`;
    })
    .join('');

  if (handles.length > 5) {
    itemsEl.insertAdjacentHTML(
      'beforeend',
      `<li class="header-list-dropdown__item text-muted">+${handles.length - 5}</li>`
    );
  }

  itemsEl.dataset.variantIds = products.map((p) => p.variants[0].id).join(',');
}

function closeAll(except) {
  dropdowns.forEach((el) => {
    if (el === except) return;
    el.querySelector('[data-list-panel]').hidden = true;
    el.querySelector('[data-list-trigger]').setAttribute('aria-expanded', 'false');
  });
}

dropdowns.forEach((el) => {
  const trigger = el.querySelector('[data-list-trigger]');
  const panel = el.querySelector('[data-list-panel]');

  trigger.addEventListener('click', (e) => {
    // Small screens: let the link navigate straight to the full page.
    if (window.matchMedia('(hover: none)').matches) return;
    e.preventDefault();
    const isOpen = !panel.hidden;
    closeAll();
    panel.hidden = isOpen;
    trigger.setAttribute('aria-expanded', String(!isOpen));
    if (!isOpen) renderDropdown(el);
  });
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-header-list-dropdown]')) closeAll();
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeAll();
});

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-wishlist-add-all-preview]')) {
    const itemsEl = e.target.closest('[data-header-list-dropdown]').querySelector('[data-list-items]');
    (itemsEl?.dataset.variantIds || '')
      .split(',')
      .filter(Boolean)
      .forEach((id) => {
        const fd = new FormData();
        fd.append('id', id);
        addToCart(fd, { openDrawer: false });
      });
  }
});

subscribe(PUB_SUB_EVENTS.wishlistUpdate, () => {
  const el = document.querySelector('[data-header-list-dropdown="wishlist"]');
  if (el && !el.querySelector('[data-list-panel]').hidden) renderDropdown(el);
});
